
import { useFormikContext } from 'formik'

import { FormikInputField } from 'components/Form/FormikInputField/FormikInputField'
import { FormikSelect } from 'components/Form/FormikSelect/FormikSelect'
import {
    type BankFieldDefinition,
    getBankFields
} from 'utils/bankFieldCatalog'

interface BankFormValues {
    bank_country: string
    beneficiaryType: string
    extra_params: Record<string, string>
}

interface Props {
    method: 'wire' | 'ach'
    showRequiredErrors: boolean
}

export const BankAdditionalFields = ({
    method,
    showRequiredErrors
}: Props) => {
    const {
        values,
        setFieldValue,
        setFieldTouched
    } = useFormikContext<BankFormValues>()

    const fields = getBankFields(
        values.bank_country,
        method,
        values.beneficiaryType
    )
console.log('[BankAdditionalFields] Formik values:', {
    transit: values.extra_params?.TRANSIT_NUMBER,
    institution: values.extra_params?.INSTITUTION_NUMBER,
    extra_params: values.extra_params
})
    if (!fields) {
        return null
    }

    /*
     * Routing number already has a dedicated field
     * in BankInformation.tsx.
     */
    const additionalFields = fields.filter(
        (field: BankFieldDefinition) =>
            field.name !== 'ROUTING_NUMBER'
    )

    if (additionalFields.length === 0) {
        return null
    }

    return (
        <>
            {additionalFields.map(field => {
                const fieldName = `extra_params.${field.name}`
                const value = values.extra_params?.[field.name] ?? ''

                return (
                    <div
                        key={field.name}
                        className='bankinfo__field bankinfo__field--half'
                    >
                        {field.type === 'select' ? (
                            <FormikSelect
                                fieldName={fieldName}
                                label={field.label}
                                selectedValue={value}
                                options={field.options}
                                searchable
                                searchPlaceholder='Search by name or code'
                                openUpwards
                                onChange={selected => {
                                    void setFieldValue(
                                        fieldName,
                                        selected.value,
                                        true
                                    )

                                    void setFieldTouched(
                                        fieldName,
                                        true,
                                        false
                                    )
                                }}
                                onTouched={() => {
                                    void setFieldTouched(
                                        fieldName,
                                        true,
                                        true
                                    )
                                }}
                            />
                        ) : (
                            <FormikInputField
                                type='text'
                                name={fieldName}
                                label={field.label}
                                value={value}
                                showRequiredErrors={showRequiredErrors}
                            />
                        )}
                    </div>
                )
            })}
        </>
    )
}
